import React from "react";
import withAULayout from "../../../components/au.desktop/layout";
import loadable from "@loadable/component";
import PageLoader from "../../../components/shared/page-loader";
import StaticPageMeta from "../../../components/shared/meta-tags/static-meta";
import { STATIC_META_CONSTANTS } from "../../../constants/meta-static-page";
const ThreeHundredPointInspectionInfo = loadable(() => import("../../../components/au.desktop/three-hundred-point-inspection-info"), {
    fallback: <PageLoader />
});

const ThreeHundredPointInspection = () => {
    return (
        <React.Fragment>
            <StaticPageMeta type={STATIC_META_CONSTANTS.THREEHUNDRED} />
            <ThreeHundredPointInspectionInfo />
        </React.Fragment>
    );
};

export default withAULayout(ThreeHundredPointInspection, true, true);

